import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// NotFoundPage.tsx
import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
const NotFoundPage = () => {
    return (_jsxs(Box, { sx: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
        }, children: [_jsx(Typography, { variant: "h1", color: "primary", gutterBottom: true, children: "404" }), _jsx(Typography, { variant: "h5", color: "textSecondary", gutterBottom: true, children: "Oops! Page not found." }), _jsx(Typography, { variant: "body1", color: "textSecondary", paragraph: true, children: "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable." }), _jsx(Button, { component: Link, to: "/", variant: "contained", color: "primary", children: "Go to Home" })] }));
};
export default NotFoundPage;
